import { FileDown, Printer, X } from "lucide-react";
import { downloadChallanPdf } from "../../lib/apiClient";
import logoIcon from "../../assets/logo_icon.png";

export function PrintChallan({ challan, business, onClose }) {
  const date = new Date(challan.date);
  const totalUnits = challan.items.reduce((sum, it) => sum + it.quantity, 0);
  return <div className="print-backdrop" role="dialog" aria-modal="true" data-testid="print-challan-dialog">
    <div className="print-shell">
      <div className="print-toolbar">
        <h3>Delivery challan · {challan.challan_no}</h3>
        <div className="actions">
          <button className="btn-ghost" data-testid="print-close-button" onClick={onClose}><X size={14} /> Close</button>
          <button className="btn-ghost" data-testid="print-download-pdf-button" onClick={() => downloadChallanPdf(challan)}><FileDown size={14} /> Download PDF</button>
          <button className="btn-primary" data-testid="print-now-button" onClick={() => window.print()}><Printer size={14} /> Print</button>
        </div>
      </div>
      <div className="print-sheet" data-testid="print-challan-sheet">
        <div className="print-header">
          <div className="print-company">
            <div className="print-company-brand">
              <img src={logoIcon} alt="" className="print-logo" />
              <h1>{business.company_name || "Surya's Exports Private Limited"}</h1>
            </div>
            <p>{business.tagline}</p>
            <p>{business.address}</p>
            <p>{business.phone} · {business.email}</p>
            {business.gstin && <p>GSTIN: {business.gstin}</p>}
          </div>
          <div className="print-title">
            <span>Delivery Challan</span>
            <h2>{challan.challan_no}</h2>
          </div>
        </div>

        <div className="print-meta">
          <div><label>Client</label><strong data-testid="print-client">{challan.client_name}</strong></div>
          <div><label>Destination</label><strong data-testid="print-destination">{challan.destination}</strong></div>
          <div><label>Vehicle no.</label><strong>{challan.vehicle_no}</strong></div>
          <div><label>Driver</label><strong>{challan.driver_name}</strong></div>
          <div><label>Date</label><strong>{date.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })}</strong></div>
          <div><label>Status</label><strong>{challan.status}</strong></div>
        </div>

        <table className="print-items">
          <thead><tr><th style={{ width: 40 }} className="center">#</th><th>Product</th><th>SKU</th><th className="center">Quantity</th><th className="center">Unit</th></tr></thead>
          <tbody>{challan.items.map((it, i) => <tr key={i}><td className="center">{i + 1}</td><td>{it.item_name}</td><td>{it.sku}</td><td className="center">{it.quantity}</td><td className="center">{it.unit}</td></tr>)}</tbody>
          <tfoot><tr><td colSpan={3} style={{ textAlign: "right" }}>Total lines · {challan.items.length}</td><td className="center">{totalUnits}</td><td className="center">units</td></tr></tfoot>
        </table>

        {challan.notes && <div className="print-notes"><label>Notes</label><p>{challan.notes}</p></div>}

        <div className="print-signatures">
          <div className="sig-block"><div className="sig-line">Prepared by</div></div>
          <div className="sig-block"><div className="sig-line">Driver signature</div></div>
          <div className="sig-block"><div className="sig-line">Received by (Client)</div></div>
        </div>

        <div className="print-footer">This is a system-generated delivery challan · {business.company_name || "Surya's Exports Private Limited"}</div>
      </div>
    </div>
  </div>;
}
